import { createRoute } from '@tanstack/react-router'

import { lazyPage } from '@/lib/lazy-page'

import { flowRoute } from './flow-route'

export const WorkflowList = lazyPage(() => import('./features/workflow-list/workflow-list.lazy'), 'WorkflowList')

export const workflowsRoute = createRoute({
  getParentRoute: () => flowRoute,
  path: 'workflows',
  component: WorkflowList,
  staticData: { title: 'Workflows' },
})

export type WorkflowEditorSearch = { version?: number; name?: string }

export function decodeWorkflowEditorSearch(search: Record<string, unknown>): WorkflowEditorSearch {
  const version = Number(search.version)
  const name = typeof search.name === 'string' && search.name.trim() !== '' ? search.name : undefined
  return {
    ...(Number.isInteger(version) && version > 0 ? { version } : {}),
    ...(name === undefined ? {} : { name }),
  }
}

export const WorkflowEditor = lazyPage(() => import('./features/workflow-editor/workflow-editor.lazy'), 'WorkflowEditor')

export const workflowEditorRoute = createRoute({
  getParentRoute: () => flowRoute,
  path: 'workflows/$key',
  validateSearch: decodeWorkflowEditorSearch,
  component: WorkflowEditor,
  staticData: { title: 'Workflow' },
})

export const WorkflowRuns = lazyPage(() => import('./features/workflow-runs/workflow-runs.lazy'), 'WorkflowRuns')

export const workflowRunsRoute = createRoute({
  getParentRoute: () => flowRoute,
  path: 'workflow-runs',
  component: WorkflowRuns,
  staticData: { title: 'Workflow runs' },
})

export const WorkflowRun = lazyPage(() => import('./features/workflow-run/workflow-run.lazy'), 'WorkflowRun')

export const workflowRunRoute = createRoute({
  getParentRoute: () => flowRoute,
  path: 'workflow-runs/$runId',
  component: WorkflowRun,
  staticData: { title: 'Workflow run' },
})
